module.exports = __webpack_public_path__ + "grootstatic/media/ce-avatar.cb2da44c.png";